/** Canonical dashboard sub-routes (sidebar + menus). */
export const DASHBOARD_ROUTES = {
  overview: '/dashboard',
  health: '/dashboard/health',
  performance: '/dashboard/performance',
  research: '/dashboard/research',
  alerts: '/dashboard/alerts',
  watchlists: '/dashboard/watchlists',
  journals: '/dashboard/journals',
  ai: '/dashboard/ai',
  aiAutomations: '/dashboard/ai-automations',
  tradingRules: '/dashboard/trading-rules',
  journalTemplate: '/dashboard/journal-template',
  settings: '/dashboard/settings',
  trade: '/dashboard/trade',
  market: '/dashboard/market',
  marketOverview: '/dashboard/market',
  marketRelativeStrength: '/dashboard/market/relative-strength',
  marketPositions: '/dashboard/market/positions',
  marketResearch: '/dashboard/market/research',
  backtest: '/dashboard/backtest',
  rsStudy: '/dashboard/rs-study',
};

/** Superuser relative-strength study, with the current list prefilled. */
export function rsStudyPath({ source, benchmark, timeframes, tickers, threshold, start } = {}) {
  const params = new URLSearchParams();
  if (benchmark) params.set('benchmark', String(benchmark).trim().toUpperCase());
  if (Array.isArray(timeframes) && timeframes.length) params.set('timeframes', timeframes.join(','));
  if (Number.isFinite(Number(threshold))) params.set('threshold', String(threshold));
  if (start) params.set('start', start);
  if (Array.isArray(tickers) && tickers.length) params.set('tickers', tickers.join(','));
  else if (source) params.set('source', source);
  const qs = params.toString();
  return qs ? `${DASHBOARD_ROUTES.rsStudy}?${qs}` : DASHBOARD_ROUTES.rsStudy;
}

/** Dashboard research with optional ticker (?symbol=). */
export function dashboardResearchPath(symbol) {
  if (!symbol || !String(symbol).trim()) return DASHBOARD_ROUTES.research;
  const sym = String(symbol).trim().toUpperCase();
  return `${DASHBOARD_ROUTES.research}?symbol=${encodeURIComponent(sym)}`;
}
